import React, { Component } from 'react';
import { reduxForm } from 'redux-form';

import { CREATE_EDIT_TRANSFER_FORM_NAME } from 'Common/FormEnum';

import { PreviewTransferComponentForm } from '../../components/createEditTransfer/PreviewTransfer';

class PreviewTransferContainer extends Component {
  render() {
    return <PreviewTransferComponentForm {...this.props} />;
  }
}

export const PreviewTransfer = reduxForm({
  form: CREATE_EDIT_TRANSFER_FORM_NAME,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(PreviewTransferContainer);



// WEBPACK FOOTER //
// ./src/pages/inventory/transaction/transfer/containers/createEditTransfer/PreviewTransfer.js